import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { shuffle } from 'lodash';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Add from '@wix/da-ds/pkg/Icons/16x16/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import StandardDropdownMenu from '../../../../../Dropdown/Preset/StandardDropdown/StandardDropdownMenu';
import { PopperDropdownManager, PopperDropdownToggle, } from '../../../../../Dropdown/PopperDropdownLayout';
import { SUGGESTIONS_I18N_KEYS } from './constants';
import s from './CommentSuggestions.scss';
var SHUFFLED_SUGGESTIONS = shuffle(SUGGESTIONS_I18N_KEYS);
var MAX_VISIBLE_SUGGESTIONS_DESKTOP = 5;
var CommentSuggestions = function (_a) {
    var onSelect = _a.onSelect;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var visibleSuggestions = isMobile
        ? SHUFFLED_SUGGESTIONS
        : SHUFFLED_SUGGESTIONS.slice(0, MAX_VISIBLE_SUGGESTIONS_DESKTOP);
    var menuSuggestions = isMobile
        ? []
        : SHUFFLED_SUGGESTIONS.slice(MAX_VISIBLE_SUGGESTIONS_DESKTOP);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['suggestions-container'] }, visibleSuggestions.map(function (i18nKey, idx) {
            var suggestionText = t(i18nKey);
            return (React.createElement(PlainButtonOrLink, { key: "suggestion-" + idx, className: cn(s['button'], s['suggestion']), onClick: function () { return onSelect(suggestionText + " "); } }, suggestionText + "..."));
        })),
        !isMobile && (React.createElement(PopperDropdownManager, null,
            React.createElement(PopperDropdownToggle, { className: cn(s['button'], s['more']), "aria-owns": "commentbox-suggestions-menu", "aria-label": t('common.more') },
                React.createElement(Add, { size: IconSize.SMALLER, disableDefaultColors: true })),
            React.createElement(StandardDropdownMenu, { id: "commentbox-suggestions-menu", items: menuSuggestions.map(function (i18nKey) {
                    var suggestionText = t(i18nKey);
                    return {
                        label: suggestionText + "...",
                        value: suggestionText + " ",
                    };
                }), role: "menu", menuClassName: s['menu'], menuScrollable: true, onSelect: onSelect })))));
};
export default CommentSuggestions;
//# sourceMappingURL=CommentSuggestions.js.map